import { render, staticRenderFns } from "./sitedetail.vue?vue&type=template&id=d85d4632&scoped=true&"
import script from "./sitedetail.vue?vue&type=script&lang=js&"
export * from "./sitedetail.vue?vue&type=script&lang=js&"
import style0 from "./sitedetail.vue?vue&type=style&index=0&id=d85d4632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85d4632",
  null
  
)

export default component.exports